import { connect } from 'react-redux';
import { getCurrentUserIdSelector } from 'selectors/user';
import BasicLeftMenu from './index';

const mapStateToProps = (state) => ({
    _me: getCurrentUserIdSelector(state)
});

export default connect(mapStateToProps, null)(BasicLeftMenu);
